export default "__VITE_ASSET__Dsn6qgAM__"